import { screeningSurveyContract } from "@clipboard-health/contract-home-health-api";
import { useGetParsedQuery } from "@src/appV2/api/useGetParsedQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type AxiosError } from "axios";

function getWorkerScreeningSurveyUrl(workerId: string) {
  return `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workers/${workerId}/screening-surveys/latest`;
}

/**
 * Fetches a worker's latest Home Health & Hospice screening survey. The endpoint returns 404 when the worker has
 * never taken the survey, which is an expected state (not an error), so we suppress error logging
 * for it and let callers treat 404 as "no survey on file".
 */
export function useGetWorkerScreeningSurvey(workerId: string) {
  return useGetParsedQuery({
    url: getWorkerScreeningSurveyUrl(workerId),
    responseSchema: screeningSurveyContract.getLatestScreeningSurvey.responses[200],
    retry: 0,
    enabled: typeof workerId === "string" && workerId.length > 0,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.HOME_HEALTH_GET_SCREENING_SURVEY_FAILURE,
      shouldLogError: (error: unknown) => (error as AxiosError)?.response?.status !== 404,
    },
  });
}
